<div class="create">
  <h2 mat-dialog-title>Another deal with this property exists</h2>
  <mat-dialog-content>
    <ng-container *ngIf="data.similarDeals?.length">
      <div class="table" *ngFor="let address of addressMatches">
        <p>
          Existing deals with <span>{{ address }}</span>
        </p>
        <table mat-table [dataSource]="data.similarDeals | filterBy: ['matchedBy'] : address">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.title }}
              <a
                matTooltip="Go to Deal"
                target="_blank"
                [routerLink]="['projects', element.pipeline_id, element.id]"
                class="goto"
                ><mat-icon>open_in_new</mat-icon>
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="project_stage">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{ element.project_stage?.name || 'Not Set' }}</td>
          </ng-container>
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Created At</th>
            <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'MMM dd, h:mm a' }}</td>
          </ng-container>
          <ng-container matColumnDef="updated_at">
            <th mat-header-cell *matHeaderCellDef>Updated At</th>
            <td mat-cell *matCellDef="let element">{{ element.updated_at | date: 'MMM dd, h:mm a' }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['title', 'project_stage', 'created_at', 'updated_at']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['title', 'project_stage', 'created_at', 'updated_at']"></tr>
        </table>
      </div>
    </ng-container>
    <p class="font-bold">Do you wish to continue creating this deal?</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="no()">No</button>
    <button mat-flat-button color="primary" (click)="yes()">Yes</button>
  </mat-dialog-actions>
</div>
